"use strict";
// Shim for `Object.values`
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (object) {
    return Object.keys(object).map(function (key) { return object[key]; });
});
